import {
  buildProbateLawFirmSelectionPayload,
  getAttorneySearchErrorMessage,
  getAttorneySearchFieldHelperText,
  mergeAttorneyIntoGuardians,
  runAttorneyAutocompleteInputChange,
} from "./attorneySearch";

export function createBondAttorneySearchErrorHandler(toast) {
  return (error) => {
    toast.error(getAttorneySearchErrorMessage(error));
  };
}

export function handleBondAttorneySelection(updateData, data, index, attorney) {
  updateData({
    ...data,
    guardians: mergeAttorneyIntoGuardians(data.guardians, index, attorney),
  });
}

export function handleBondLawFirmChange(
  updateData,
  data,
  newValue,
  lawFirmAddress,
  attorneyOfRecord,
  attorneyInvolved,
  onClear
) {
  if (newValue) {
    updateData(
      buildProbateLawFirmSelectionPayload(
        data,
        newValue.value,
        lawFirmAddress,
        attorneyOfRecord,
        attorneyInvolved
      )
    );
    return;
  }

  if (onClear) {
    onClear();
  }
}

export function runBondLawFirmAttorneySync(
  lawFirm,
  fetchLocationsByLawFirm,
  fetchAttorneysByLawFirm
) {
  if (!lawFirm) {
    return;
  }

  fetchLocationsByLawFirm(lawFirm);
  fetchAttorneysByLawFirm(lawFirm);
}

export function createBondAttorneyInputChangeHandler(debouncedSearch) {
  return (_event, value, reason) => {
    runAttorneyAutocompleteInputChange(reason, value, debouncedSearch);
  };
}

export function buildBondAttorneySearchInputHandler(setAttorneySearchInput, debouncedSearch) {
  const searchHandler = createBondAttorneyInputChangeHandler(debouncedSearch);
  return (event, value, reason) => {
    setAttorneySearchInput(value);
    searchHandler(event, value, reason);
  };
}

export function buildBondGuardianAttorneySearchHelperText(
  attorneySearchInput,
  loadingAttorneys,
  attorneyCount,
  fieldError
) {
  return (
    fieldError ||
    getAttorneySearchFieldHelperText(attorneySearchInput, loadingAttorneys, attorneyCount)
  );
}

export function handleBondGuardianManualAttorneyEntry({
  updateData,
  data,
  index,
  guardians,
  clearAttorneys,
  setAttorneySearchInput,
}) {
  const updatedGuardians = [...guardians];
  updatedGuardians[index] = {
    ...updatedGuardians[index],
    showAttorneyForm: true,
    attorney: null,
  };
  clearAttorneys();
  setAttorneySearchInput("");
  updateData({ ...data, guardians: updatedGuardians });
}

export function getBondGuardianAttorneyOptionLabel(option) {
  return option?.label || "";
}

export function passThroughBondGuardianAttorneyOptions(options) {
  return options;
}

export function resolveBondGuardianAttorneyValue(attorneys, guardian) {
  return attorneys.find((attorney) => attorney.value === guardian.attorney) || null;
}

export function findBondAttorneyByGuardian(attorneys, guardian) {
  if (!guardian?.attorney) {
    return null;
  }
  return attorneys.find((entry) => entry.value === guardian.attorney) || null;
}

export function buildBondGuardianAttorneyChangeHandler(onSelect, guardianIndex) {
  return (_event, newValue) => onSelect(guardianIndex, newValue);
}

export function buildBondGuardianAttorneySearchProps({
  attorneySearchInput,
  setAttorneySearchInput,
  attorneys,
  loadingAttorneys,
  debouncedSearchAttorneys,
  clearAttorneys,
  guardian,
  guardianIndex,
  updateData,
  data,
  guardians,
  onSelect,
  fieldError = "",
  required = false,
}) {
  return {
    attorneys,
    loadingAttorneys,
    attorneySearchInput,
    setAttorneySearchInput,
    debouncedSearchAttorneys,
    clearAttorneys,
    guardian,
    guardianIndex,
    updateData,
    data,
    guardians,
    onSelect,
    fieldError,
    required,
  };
}
